import {combineReducers} from '@reduxjs/toolkit';

import {entitlementGrantChangeLogStateSlice} from './slices/entitlement-grant-change-log-state.slice';
import {entitlementGrantChangeLogSlice} from './slices/entitlement-grant-change-log.slice';

export const entitlementGrantChangeLogReducer = combineReducers({
    events: entitlementGrantChangeLogSlice.reducer,
    state: entitlementGrantChangeLogStateSlice.reducer,
});
